export default __webpack_public_path__ + "static/cruiselines-royal-ship-5-8ec13da4eb10012b3dcee8c81e7a967d.jpg";